import { Years } from "./types";

export const viewState = {

    defaultYears: undefined as Years,

    timelineZoom: 150,

    scroll: {
        scrollLeft: <number>undefined,
        scrollTop: 0
    }

}
